import {Injectable} from '@angular/core';
import {ResourceService} from '~/app/core/common/services/ResourceService';
import {Item} from '~/app/core/common/models/item';
import {OrderItemSerializer} from '../serializers/OrderItemSerializer';
import {map} from 'rxjs/operators';
import {OrderReviewItem} from '~/app/core/common/models/OrderReviewItem';
import {ApiService} from '~/app/core/common/services/api.service';
import {BaseService} from '~/app/core/common/services/base.service';


@Injectable({
    providedIn: 'root'
})
export class ItemService extends ResourceService<OrderReviewItem> {
    constructor(public baseService: BaseService,
                public apiService: ApiService,
                ) {
        super(baseService,
            '',
            '',
            new OrderItemSerializer()
        );
    }

    public listItemsForOrderCustomer(storeNumber: string, trackingId: string) {
        return this.baseService.getHttpObject<Item>(
            'listItemsForOrderCustomer',
            'item-service',
            this.apiService.allItemNumbersURL.replace('store_number', storeNumber).replace('tracking_id', trackingId))
            .pipe(map((data: any) => this.convertData(data)));
    }
}
